import { connect } from 'react-redux';

import { acceptCookies as acceptCookiesProcess } from 'actions/global';

import CookieBar from './component';

const mapStateToProps = ({ global: { cookies: { acceptCookies } } }) => ({
	active: !acceptCookies,
});

const mapDispatchToProps = dispatch => ({
	onConfirm: () => {
		dispatch(acceptCookiesProcess());
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(CookieBar);



// WEBPACK FOOTER //
// ./src/components/molecules/CookieBar/index.js